export default "__VITE_ASSET__DithU6hb__"